import {fetch} from "utils/dataAccess";

export async function addRetailerItemsToTask(taskId, inventoryId, retailerIds) {
    const response = await fetch(`/w_m_s_tasks/${taskId}/add_retailer_items`, {
        method: 'PATCH',
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({
            inventoryId: inventoryId,
            retailers: retailerIds,
        }),
    }, false, true);

    return await response.json();
}
